import React from 'react';

const Role = ({ rowData, userRoles }) => {
    return userRoles.length > 0 && (
        <span>
            {userRoles.find(r => r.value === rowData.role)?.text}
        </span>
    );
}

export default Role;
